module.exports = __webpack_public_path__ + "img/1484490705.4ad264bf.jpg";